import * as types from "./types";

function dataSaved(payload) {
  return { type: types.DATA_SAVED, payload };
}

function resetDataSaved() {
  return { type: types.RESET_DATA_SAVED };
}

function obtenerListaColegios(payload) {
  return { type: types.FETCH, payload };
}

function obtenerDetalleColegio(payload) {
  return { type: types.FETCH_DETALLE, payload };
}

function itemListaColegiosEliminado(payload) {
  return { type: types.REMOVED, payload };
}

function resetListaColegios() {
  return { type: types.RESET };
}

function resetDetalleColegio() {
  return { type: types.RESET_DETALLE };
}

/*---*/
export {
  dataSaved,
  resetDataSaved,
  obtenerListaColegios,
  itemListaColegiosEliminado,
  resetListaColegios,
  obtenerDetalleColegio,
  resetDetalleColegio
};



// WEBPACK FOOTER //
// ./src/ducks/colegios/actions.js